module.exports = __webpack_public_path__ + "static/media/orientation-landscape.544d2293.svg";